import { getConfig } from 'services/config/ConfigService';
import styled from 'styled-components';
let config;
let primary;
let secondary;
const Button = styled.button.attrs( async (props) => { 
  config = await getConfig();
  primary = config.color1;
  secondary = config.color2;
  return ({ type: props.type || 'button', })
})`
  border-width: 2px;
  border-style: solid;
  border-color: ${props => props.primary || 'lightgrey'};
  background-color: ${props => props.bg || 'lightgrey'};
  color: ${props => props.color || 'white'};
  padding: 4px 17px;
  border-radius: ${props => props.squared ? '5px' : '30px'};
  width: ${props => props.full ? '100%' : 'auto'};
  height: 38px;
  font-size: 16px;
  font-weight: 600;
  min-width: 200px;
`;
const ButtonPrimary = styled(Button)`
  border-color: ${primary};
  background-color: ${primary};
`;
const ButtonSecondary = styled(Button)`
  border-color: ${props => props.isCourse === true ? '#228B22' : secondary};
  background-color: ${props => props.isCourse === true ? '#228B22' : secondary};
`;
const ButtonOutline = styled(Button)`
  background-color: #FFFFFF;
  color: ${props => props.color || secondary};
  border-color: ${props => props.color || secondary};
`;
const ButtonSmall = styled(Button)`
  padding: 5px 10px;
  font-size: 12px;
  min-width: auto;
  margin-left: 10px;
  border: 0;
  height: auto;
`;
const ButtonOutlinePrimary = styled(ButtonOutline)`
  color: ${primary};
  border-color: ${primary};
`;
const ButtonOutlineSecondary = styled(ButtonOutline)`
  color: ${secondary};
  border-color: ${secondary};
`;
const ButtonPrimaryTransparent = styled(ButtonOutlinePrimary)`
  background-color: transparent;
  border-color: transparent;
  text-decoration: underline;
`;
const ButtonSecondaryTransparent = styled(ButtonPrimaryTransparent)`
  color: ${secondary};
`;
const ButtonReadArticle = styled(Button)`
  border-color: green;
  background-color: green;
  justify-content: space-between;
  align-items: center;
  display: flex;
  flex-wrap: wrap;
`;
export {
  Button,
  ButtonPrimary,
  ButtonSecondary,
  ButtonOutline,
  ButtonOutlinePrimary,
  ButtonOutlineSecondary,
  ButtonPrimaryTransparent,
  ButtonSecondaryTransparent,
  ButtonReadArticle,
  ButtonSmall
}
